/**
 * JWT Utilities
 * Helper functions for JWT token parsing and user ID extraction
 */

/**
 * Extracts the user ID from a JWT token
 * @param userToken - The JWT token to parse
 * @returns The user ID from the token payload
 * @throws Error if no user ID is found in the token
 */
export const extractUserIdFromToken = (userToken: string): string => {
  const base64Url = userToken.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map((c: string) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
      .join('')
  );
  const decodedJwt = JSON.parse(jsonPayload);
  const userId = decodedJwt.user_id;

  if (!userId) {
    throw new Error('No user ID found in token');
  }

  return userId;
}; 